export enum MapActionsEnum{
    none = -1,
    categoryFilter = 1,
    routes = 2,
    minigame = 3
}